/* Garage Heater Advertorial (gh-*) sections: countdown, smooth scroll, product gallery, variants, add to cart */
(function () {
  if (window.__ghInit) return;
  window.__ghInit = true;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---- Countdown: daily (to midnight), fixed date, or evergreen minutes per visitor ---- */
  function countdownEnd(el) {
    var mode = el.dataset.mode || 'daily';
    var now = Date.now();
    if (mode === 'date') {
      var end = Date.parse(el.dataset.end || '');
      return isNaN(end) ? now : end;
    }
    if (mode === 'minutes') {
      var span = Math.max(1, Number(el.dataset.minutes) || 60) * 60000;
      var key = 'gh-count-' + (el.dataset.key || 'default');
      var stored = 0;
      try { stored = Number(localStorage.getItem(key)) || 0; } catch (e) { /* storage blocked */ }
      if (!stored || stored <= now) {
        stored = now + span;
        try { localStorage.setItem(key, String(stored)); } catch (e) { /* storage blocked */ }
      }
      return stored;
    }
    var midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime();
  }

  function initCountdown(el) {
    if (el.dataset.ghReady) return;
    el.dataset.ghReady = '1';
    var end = countdownEnd(el);
    var h = qs('[data-gh-h]', el), m = qs('[data-gh-m]', el), s = qs('[data-gh-s]', el);
    function tick() {
      var left = Math.max(0, end - Date.now());
      if (left === 0 && el.dataset.mode !== 'date') { end = countdownEnd(el); left = Math.max(0, end - Date.now()); }
      if (left === 0 && el.dataset.mode === 'date' && el.dataset.hideOnEnd === 'true') {
        el.hidden = true;
        return;
      }
      var total = Math.floor(left / 1000);
      var hours = Math.floor(total / 3600);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(Math.floor((total % 3600) / 60));
      if (s) s.textContent = pad(total % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Smooth scroll for in-page links (e.g. CTA → #offer) ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-gh-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    var bar = qs('.gh-bar--sticky');
    var offset = bar ? bar.offsetHeight : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  /* ---- Gallery: swipe the main image or tap a thumbnail ---- */
  function initGallery(gallery) {
    if (gallery.dataset.ghReady) return;
    gallery.dataset.ghReady = '1';
    var track = qs('[data-gh-slides]', gallery);
    var thumbs = qsa('[data-gh-thumb]', gallery);
    if (!track) return;
    var slides = qsa('[data-gh-slide]', track);

    function setActive(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    gallery.ghGoTo = function (i, smooth) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { gallery.ghGoTo(i); });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        setActive(Math.min(i, slides.length - 1));
      });
    }, { passive: true });
  }

  /* ---- Product: variants + add to cart ---- */
  function themeCart(root) {
    if (root.dataset.cartType === 'page') return null;
    var cart = qs('cart-drawer') || qs('cart-notification');
    return cart && typeof cart.renderContents === 'function' ? cart : null;
  }

  /* Cart drawer apps (UpCart) replace the theme drawer; returns true when one is on the page */
  function openAppCart() {
    var hasUpcart = typeof window.upcartOpenCart === 'function' || !!window.upcartSettings;
    if (!hasUpcart) return false;
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
    } catch (err) { /* the app opens its drawer on its own after /cart/add */ }
    return true;
  }

  function selectVariant(root, btn) {
    qsa('[data-gh-variant]', root).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    var d = btn.dataset;
    qsa('input[name="id"]', root).forEach(function (input) { input.value = d.variantId; });
    qsa('[data-gh-price]', root).forEach(function (el) { el.textContent = d.price; });
    qsa('[data-gh-compare]', root).forEach(function (el) { el.textContent = d.compare || ''; el.hidden = !d.compare; });
    qsa('[data-gh-badge]', root).forEach(function (el) {
      var tpl = el.dataset.template || '';
      el.textContent = tpl.replace('[percent]', d.percent || '').replace('[amount]', d.saveAmount || '');
      el.hidden = !d.compare;
    });
    qsa('[data-gh-atc]', root).forEach(function (b) {
      b.dataset.available = d.available;
      renderAtc(b);
    });
    if (d.mediaIndex) {
      var gallery = qs('[data-gh-gallery]', root);
      if (gallery && gallery.ghGoTo) gallery.ghGoTo(Number(d.mediaIndex));
    }
  }

  function renderAtc(btn) {
    var label = qs('[data-gh-atc-label]', btn);
    var root = btn.closest('[data-gh-product]');
    var priceEl = root && qs('[data-gh-variant][aria-pressed="true"]', root);
    var price = priceEl ? priceEl.dataset.price : (btn.dataset.price || '');
    var state = btn.dataset.state || 'idle';
    var available = btn.dataset.available !== 'false';
    btn.disabled = !available || state === 'busy';
    if (!label) return;
    label.textContent = !available ? (btn.dataset.soldOut || 'Sold out') :
      state === 'busy' ? (btn.dataset.busy || 'Adding…') :
      state === 'added' ? (btn.dataset.added || 'Added!') :
      (btn.dataset.template || 'Add to cart').replace('[price]', price);
  }

  function addToCart(form, btn) {
    var root = form.closest('[data-gh-product]');
    if ((btn.dataset.state || 'idle') === 'busy') return;
    var errorEl = qs('[data-gh-error]', form);
    if (errorEl) errorEl.hidden = true;
    var setState = function (next) { btn.dataset.state = next; renderAtc(btn); };
    var behavior = root.dataset.addBehavior || 'theme';
    var cart = behavior === 'theme' ? themeCart(root) : null;
    var idInput = qs('input[name="id"]', form);
    var qtyInput = qs('input[name="quantity"]', root);
    var payload = { id: Number(idInput.value), quantity: Math.max(1, Number(qtyInput && qtyInput.value) || 1) };
    if (cart) {
      payload.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    setState('busy');
    fetch(root.dataset.addUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data && (data.description || data.message) || r.status);
          return data;
        });
      })
      .then(function (data) {
        setState('added');
        if (behavior === 'checkout') { window.location.href = '/checkout'; return; }
        var stay = false;
        if (cart) {
          try { cart.renderContents(data); stay = true; } catch (err) { /* fall through */ }
          var drawer = qs('cart-drawer');
          if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
        }
        if (!stay && behavior === 'theme' && root.dataset.cartType !== 'page') stay = openAppCart();
        if (stay) { setTimeout(function () { setState('idle'); }, 2000); return; }
        window.location.href = root.dataset.cartUrl || '/cart';
      })
      .catch(function (err) {
        setState('idle');
        if (errorEl) { errorEl.textContent = String(err.message || err); errorEl.hidden = false; }
      });
  }

  function initProduct(root) {
    if (root.dataset.ghReady) return;
    root.dataset.ghReady = '1';
    qsa('[data-gh-variant]', root).forEach(function (b) {
      b.addEventListener('click', function () { selectVariant(root, b); });
    });
    qsa('[data-gh-qty]', root).forEach(function (wrap) {
      var input = qs('input', wrap);
      qsa('button', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (Number(input.value) || 1) + Number(b.dataset.step));
          input.value = v;
        });
      });
    });
    qsa('form[data-gh-form]', root).forEach(function (form) {
      var btn = qs('[data-gh-atc]', form);
      if (btn) renderAtc(btn);
      form.addEventListener('submit', function (e) {
        if (!btn) return;
        e.preventDefault();
        addToCart(form, btn);
      });
    });
  }

  /* ---- Sticky button: shows after scrolling, hides while a page CTA / the product section is on screen ---- */
  function initSticky(bar) {
    if (bar.dataset.ghReady) return;
    bar.dataset.ghReady = '1';
    var showAfter = Number(bar.dataset.showAfter) || 0;
    var sel = bar.dataset.hideOn || '';
    var targets = sel ? qsa(sel).filter(function (el) { return !bar.contains(el); }) : [];
    var onScreen = 0;
    var link = qs('a', bar);
    function update() {
      var show = window.pageYOffset >= showAfter && onScreen === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (link) link.tabIndex = show ? 0 : -1;
    }
    if (targets.length && 'IntersectionObserver' in window) {
      var seen = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
        onScreen = seen.size;
        update();
      });
      targets.forEach(function (t) { io.observe(t); });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init(scope) {
    qsa('[data-gh-countdown]', scope).forEach(initCountdown);
    qsa('[data-gh-gallery]', scope).forEach(initGallery);
    qsa('[data-gh-product]', scope).forEach(initProduct);
    qsa('[data-gh-sticky]', scope).forEach(initSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  /* Theme editor: re-init sections when they are added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* Reset buttons when the page comes back from the back/forward cache */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    qsa('[data-gh-atc]').forEach(function (b) { b.dataset.state = 'idle'; renderAtc(b); });
  });
})();
